import { GameScene } from './scenes/GameScene';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  width: window.innerWidth,
  height: window.innerHeight,
  backgroundColor: '#2a2622',
  scene: [GameScene],
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  input: {
    activePointers: 3,
  },
};

const game = new Phaser.Game(config);

// postMessage 预留接口：向父页面发送游戏事件
(window as any).__tcmRpg = {
  game,
  emit(event: string, data?: any) {
    window.parent.postMessage({ source: 'tcm-rpg', event, data }, '*');
  },
};

// 接收父页面命令
window.addEventListener('message', (e) => {
  const msg = e.data;
  if (msg?.target !== 'tcm-rpg') return;
  const scene = game.scene.getScene('GameScene') as GameScene;
  if (!scene) return;
  switch (msg.command) {
    case 'collect': scene.collectHerb(msg.herbId); break;
    case 'talk': scene.talkTo(msg.npcId); break;
    case 'showInventory': scene.toggleInventory(); break;
    case 'showHerbBook': scene.toggleHerbBook(); break;
  }
});
